export interface ConversionCostsByCountryInfo {
  country: {
    code: string;
    name: string;
    notes: { name: string; notes: string[] }[];
    liability: { tier: string; link: string };
  };
  taxes: {
    employer: {
      total: number;
      contributions: { name: string; group: string; amount: number }[];
    };
    employee: {
      total: number;
      contributions: { name: string; group: string; amount: number }[];
    };
  };
  annualGrossSalary: number;
  stateOrProvince: string | null;
  currency: {
    code: string;
    name: string;
  };
  fees: {
    oyster: {
      native: {
        value: number;
        rate: number | null;
      };
      converted: {
        value: number;
        rate: number | null;
      };
    };
    vat: {
      value: number | null;
      rate: number | null;
    };
  };
  totals: {
    netSalary: number;
    employerCosts: number;
  };
}

export const getCostInfoForCountry = ({
  annualGrossSalary,
  countryCode,
  currencyCode = 'USD',
  stateOrProvince,
}: {
  annualGrossSalary: number;
  countryCode: string;
  currencyCode?: string;
  stateOrProvince?: string;
}) => {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');

  const body = JSON.stringify({
    query: `
    fragment TaxData on SalaryTax {
      total
      contributions {
        name
        group
        amount
      }
    }

    fragment FeeData on SalaryFee {
      value
      rate
    }

    fragment CommonSalaryData on SalaryCalculation {
      country {
        code
        name
        notes {
          name
          notes
        }
        liability {
          tier
          link
        }
      }
      taxes {
        employer {
          ...TaxData
        }
        employee {
          ...TaxData
        }
      }
      annualGrossSalary
      stateOrProvince
      currency {
        code
        name
      }
      fees {
        oyster {
          native {
            ...FeeData
          }
          converted {
            ...FeeData
          }
        }
        vat {
          ...FeeData
        }
      }
      totals {
        netSalary
        employerCosts
      }
    }
    
    query BulkSalaryCalculations($calculationQueries: [SalaryQueryInput!]!) {
      bulkSalaryCalculations(calculationQueries: $calculationQueries) {
        ...CommonSalaryData
      }
    }
`,
    variables: {
      calculationQueries: [
        {
          annualGrossSalary,
          countryCode,
          currencyCode,
          stateOrProvince,
        },
      ],
    },
  });
  const requestOptions = {
    method: 'POST',
    headers,
    body,
  };

  return fetch(
    'https://app.oysterhr.com/api/graphql/cost-calculator',
    requestOptions
  )
    .then((response) => response.json())
    .then(({ data, errors }) => {
      return {
        data: data
          ? (data.bulkSalaryCalculations[0] as ConversionCostsByCountryInfo)
          : null,
        error: errors?.length ? errors[0] : null,
      };
    })
    .catch((error) => ({ error, data: null }));
};
